export const MY_HUNGRYROOT_ROUTE = '/myhungryroot/';
export const EDIT_DELIVERY_RECIPES_ROUTE = '/edit-delivery/recipes/';
export const EDIT_DELIVERY_GROCERIES_ROUTE = '/edit-delivery/groceries/';
export const PLAN_ROUTE = '/plan/';
export const LOGIN_ROUTE = '/login/';
export const WALLET_ROUTE = '/wallet/';
export const CHECKOUT_CONGRATS_ROUTE = '/checkout/congrats/';
export const CHECKOUT_SHIPPING_ROUTE = '/checkout/shipping/';
export const CHECKOUT_PAYMENT_ROUTE = '/checkout/payment/';
export const CHECKOUT_V2_PAYMENT_ROUTE = '/checkout/payment-v2/';
export const CHECKOUT_V2_SHIPPING_ROUTE = '/checkout/shipping-v2/';
export const REACTIVATE_ROUTE = '/account/reactivated/';
export const ORDER_ROUTE = '/order/';
export const SUPPORT_ARTICLE_ROUTE = '/support-articles/';
export const SUPPORT_ARTICLE_QUICK_TOUR_ROUTE = '/support-articles/quick-tour/';
export const SUPPORT_ARTICLE_SHOP_WITH_CREDITS_ROUTE =
  '/support-articles/shop-with-credits/';
export const SUPPORT_ARTICLE_FIRST_DELIVERY_ROUTE =
  '/support-articles/first-delivery/';
export const SUPPORT_ARTICLE_FOOD_PROFILE_ROUTE =
  '/support-articles/food-profile/';
export const SUPPORT_ARTICLE_SCHEDULE_MANAGEMENT_ROUTE =
  '/support-articles/schedule-management/';
export const SUPPORT_ARTICLE_DELIVERY_ISSUES_ROUTE =
  '/support-articles/delivery-issues/';
export const SUPPORT_ARTICLE_EDIT_ORDER_ROUTE = '/support-articles/edit-order/';
export const SUPPORT_ARTICLE_EDIT_PLAN_ROUTE = '/support-articles/edit-plan/';

export const ACCOUNT_HISTORY_ROUTE = '/account/history/';
export const ACCOUNT_SETTINGS_ROUTE = '/account/settings/';
export const ACCOUNT_PREFERENCES_ROUTE = '/preferences/';
export const ACCOUNT_HELP_CENTER_ROUTE = '/faq/';
export const ACCOUNT_ORDER_HISTORY_ROUTE = '/account/history/';
export const ACCOUNT_REFERRAL_ROUTE = '/account/referral/';

export const GIFT_ROUTE = '/gift/';
export const COMMUNITY_URL = 'https://www.facebook.com/groups/hungryroot';
export const EDIT_DELIVERY_RECIPES_FOR_YOU_ROUTE =
  '/edit-delivery/recipes/for-you/';
export const EDIT_DELIVERY_GROCERIES_FOR_YOU_ROUTE =
  '/edit-delivery/groceries/for-you/';

export const CA_EMPLOYEE_PRIVACY_POLICY_ROUTE = '/privacy/ca-employee-notice/';
export const UPCOMING_ORDERS_ROUTE = '/upcoming';

export { isEqualPathnames } from './isEqualPathnames';
export { isEqualToAtLeastOnePathname } from './isEqualToAtLeastOnePathname';

export const PRECHECKOUT_PLAN_ROUTE = '/survey/plan/';

export const generateDynamicAccountOrdersRoute = ({
  orderId,
}: {
  orderId: number | string;
}) => `/account/orders/${orderId}/`;
